module.exports = require('./helpers/bundle-url').getBundleURL('ksUvU') + "contactus.38f422fd.png" + "?" + Date.now();